import { render, staticRenderFns } from "./Soldes.vue?vue&type=template&id=7cb9f67e"
import script from "./Soldes.vue?vue&type=script&lang=js"
export * from "./Soldes.vue?vue&type=script&lang=js"
import style0 from "./Soldes.vue?vue&type=style&index=0&id=7cb9f67e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports